import { GithubService, IGithubService } from "./github";

export interface IProvidedService {
  github: IGithubService;
}

export const initializeService = (): IProvidedService => ({
  github: new GithubService(),
})